import { Image, ImageProps } from 'react-native';
import { ImageProps as ExpoImageProps } from 'expo-image';

export const CachedImage = ({
	source,
	contentFit,
	...imageProps
}: ImageProps & Pick<ExpoImageProps, 'contentFit'>) => {
	return <Image source={source} resizeMode={contentFit} {...imageProps} />;
};
